import React from 'react';
import './Spinner.css';

/*
 * Spinner — inline indeterminate loader. Inherits color via currentColor, so
 * it tints to match its context (e.g. white inside a primary Button).
 * size = diameter in px. Purely presentational.
 */
export default function Spinner({ size = 16, className = '', label = 'Loading', ...rest }) {
  return (
    <span
      className={`ui-spinner${className ? ' ' + className : ''}`}
      role="status"
      aria-label={label}
      style={{ width: size, height: size }}
      {...rest}
    >
      <svg viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden="true" focusable="false">
        <circle className="ui-spinner__track" cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" />
        <path className="ui-spinner__arc" d="M12 3a9 9 0 0 1 9 9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    </span>
  );
}
